import styled from 'components/styled/styled';
import { FAQ_LIST, FAQ_LIST_EDITOR } from 'constants/staticData.constants';
import React from 'react';
import { FlexContainer } from 'components/styled/layout.styled';
import { H, P } from 'components/styled/typography.styled';
import bgx2 from 'assets/images/reviews_bg/pattern-bg@2x.webp';
import bg from 'assets/images/reviews_bg/pattern-bg.webp';
import PlusSign from 'assets/svgs/plus_sign.svg';
import { useLocation } from '@reach/router';
import { getQuery } from 'utils/query.utils';

const BackgroundContainer = styled(FlexContainer)`
  justify-content: center;
  background: url(${bgx2});
  background-repeat: no-repeat;
  @media only screen and (max-width: 769px) {
    background: url(${bg});
  }
`;

const FixedContainer = styled(FlexContainer)`
  max-width: 800px;
  flex-direction: column;
  align-items: center;
  padding: 16px 32px;
  > h3 {
    font-size: 56px;
    text-align: center;
    width: 100%;
  }
  @media only screen and (max-width: 769px) {
    > h3 {
      font-size: 36px;
      width: 100%;
    }
  }
`;

const Questions = styled(FlexContainer)`
  flex-direction: column;
  align-items: center;
`;

const Question = styled(FlexContainer)<{ isOpen: boolean }>`
  background-color: #fff;
  box-shadow: 0 16px 120px 0 #ede6e6cc;
  padding: 26px 32px;
  overflow: hidden;
  flex-direction: row;
  margin: 8px 0;
  border-radius: 24px;

  > div {
    flex-direction: column;
    justify-content: center;
  }
  > svg {
    flex-shrink: 0;
    height: 32px;
    width: 32px;
    margin-right: 16px;
    transform: ${({ isOpen }) => (isOpen ? 'rotate(45deg)' : 'none')};
    transition: 200ms linear;
  }
  h1 {
    margin-bottom: 8px;
    margin-top: 4px;
  }
  p {
    font-weight: 500;
    max-height: ${({ isOpen }) => (isOpen ? '100vh' : 0)};
    opacity: ${({ isOpen }) => (isOpen ? '0.7' : 0)};
    margin: 0;
    transition: all 300ms ease-in-out;
    padding: 0;
  }
`;

const FaqPage = () => {
  const [faqID, setFaqID] = React.useState<null | number>(null);
  const location = useLocation();
  const isEditorFaq = getQuery(location.search, 'editor');

  const handleClick = (id: number) => {
    if (id === faqID) {
      setFaqID(null);
    } else {
      setFaqID(id);
    }
  };
  return (
    <BackgroundContainer>
      <FixedContainer>
        <H>Frequently Asked Questions</H>
        <Questions>
          {(isEditorFaq ? FAQ_LIST_EDITOR : FAQ_LIST).map((faq) => (
            <Question
              isOpen={faq.id === faqID}
              onClick={() => handleClick(faq.id)}
            >
              <PlusSign />
              <FlexContainer>
                <H small>{faq.question}</H>
                <P light>{faq.answer}</P>
              </FlexContainer>
            </Question>
          ))}
        </Questions>
      </FixedContainer>
    </BackgroundContainer>
  );
};

export default FaqPage;
